export const Pages = {
  size: 30,
  debounceTime:300,
  distance: 2,
  throttle: 50,
  student_id_length: 7,
};
